import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const DebitNoteEntryTable = (props) => {
    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Debit note details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[12px] mb-3">
                        <div className="input-grp">
                            <label>Debit note no</label>
                            <TextInput type="number" id="debitNoteNo" name="debitNoteNo"
                                value={props.debitNoteDetails.debitNoteNo} handleChange={(event) => props.handleChange(event, "debitNoteNo")} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Date</label>
                            <TextInput type="date" id="date" name="date" value={props.debitNoteDetails.date}
                                handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Party account</label>
                            <SingleSelectWithSearch
                                drpIdentity={"partyList"}
                                optionArray={props.debitNoteDetails.partyList}
                                value={props.debitNoteDetails.idPartyAccount}
                                searchText={props.debitNoteDetails.partyACName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="partyAccount" name="partyAccount" value={props.debitNoteDetails.partyAccount} className={props.validState?.error?.partyAccount !== undefined ? "error" : ""}
                            handleChangeTest={(event) => props.handleSelectChange(event, "partyAccount")} />  */}
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Particulars</label>
                            <SingleSelectWithSearch
                                drpIdentity={"particulars"}
                                optionArray={props.debitNoteDetails.particularsList}
                                value={props.debitNoteDetails.particularsId}
                                searchText={props.debitNoteDetails.particularsName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                // classParams={props.validState?.error?.particularsId !== undefined ? "error" : ""}
                            />
                            {/* <TextInput type="text" id="particulars" name="particulars" value={props.debitNoteDetails.particulars} handleChange={(event) => props.handleChange(event, "particulars")} className={props.validState?.error?.particulars !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Purchase No</label>
                            <SingleSelectWithSearch
                                drpIdentity={"purchaseNoList"}
                                optionArray={props.debitNoteDetails.purchaseNoList}
                                value={props.debitNoteDetails.idMaterialInward}
                                searchText={props.debitNoteDetails.inwardNo}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                            // classParams={props.validState?.error?.idMaterialInward !== undefined ? "error" : ""}
                            />
                            {/* <TextInput type="number" id="purchaseNo" name="refNo" value={props.debitNoteDetails.purchaseNo} handleChange={(event) => props.handleChange(event, "purchaseNo")} className={props.validState?.error?.purchaseNo !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp">
                            <label>Amount</label>
                            <TextInput type="number" id="amount" name="amount" value={props.debitNoteDetails.amount} handleChange={(event) => props.handleChange(event, "amount")} className={props.validState?.error?.amount !== undefined ? "error" : ""} />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Reference no</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.debitNoteDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} className={props.validState?.error?.refNo !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp">
                            <label>Tax type</label>
                            <SingleSelectWithSearch
                                drpIdentity={"NoteType"}
                                optionArray={props.debitNoteDetails.taxtTypeList}
                                value={props.debitNoteDetails.idTaxtType}
                                searchText={props.debitNoteDetails.taxtTypeName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idTaxtType !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="taxType" name="taxType" value={props.debitNoteDetails.taxType} handleChangeTest={(event) => props.handleSelectChange(event, "taxType")} className={props.validState?.error?.taxType !== undefined ? "error" : ""}/> */}
                        </div>
                        <div className="input-grp">
                            <label>Tax</label>
                            <SingleSelectWithSearch
                                drpIdentity={"TaxtStructureList"}
                                optionArray={props.debitNoteDetails.taxtStructureList}
                                value={props.debitNoteDetails.idTaxStructure}
                                searchText={props.debitNoteDetails.taxStructureName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idTaxStructure !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="tax" name="tax" value={props.debitNoteDetails.tax} handleChangeTest={(event) => props.handleSelectChange(event, "tax")} className={props.validState?.error?.tax !== undefined ? "error" : ""} /> */}
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">
                        {/* <div className="input-grp">
                            <label>SGST</label>
                            <TextInput type="number" id="sgst" name="sgst" value={props.debitNoteDetails.sgst} handleChange={(event) => props.handleChange(event, "sgst")} className={props.validState?.error?.sgst !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>CGST</label>
                            <TextInput type="number" id="cgst" name="cgst" value={props.debitNoteDetails.cgst} handleChange={(event) => props.handleChange(event, "cgst")} className={props.validState?.error?.cgst !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>IGST</label>
                            <TextInput type="number" id="igst" name="igst" value={props.debitNoteDetails.igst} handleChange={(event) => props.handleChange(event, "igst")} className={props.validState?.error?.igst !== undefined ? "error" : ""} />
                        </div> */}
                        <div className="input-grp">
                            <label>SGST {props.debitNoteDetails.taxtTypeName === 'INTRASTATE' && props.debitNoteDetails.sgst > 0 ? `- ${props.debitNoteDetails.sgst}` : ""}</label>
                            <TextInput type="number" id="sgst" name="sgstAmt" value={props.debitNoteDetails.sgstAmt} handleChange={(event) => props.handleChange(event, "sgst")} className={props.validState?.error?.sgst !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>CGST  {props.debitNoteDetails.taxtTypeName === 'INTRASTATE' && props.debitNoteDetails.cgst > 0 ? `- ${props.debitNoteDetails.cgst}` : ""}</label>
                            <TextInput type="number" id="cgst" name="cgstAmt" value={props.debitNoteDetails.cgstAmt} handleChange={(event) => props.handleChange(event, "cgst")} className={props.validState?.error?.cgst !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>IGST {props.debitNoteDetails.igst > 0 ? props.debitNoteDetails.taxtTypeName === 'INTRASTATE' ? "" : `-${props.debitNoteDetails.igst}` : ""}</label>
                            <TextInput type="number" id="igst" name="igstAmt" value={props.debitNoteDetails.igstAmt} handleChange={(event) => props.handleChange(event, "igst")} className={props.validState?.error?.igst !== undefined ? "error" : ""} disabled />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Final Amount</label>
                            <TextInput type="number" id="finalAmt" name="finalAmt" value={props.debitNoteDetails.finalAmt} handleChange={(event) => props.handleChange(event, "finalAmt")} className={props.validState?.error?.finalAmt !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>TCS percentage</label>
                            <TextInput type="number" id="tcsPercentage" name="tcsPercentage" value={props.debitNoteDetails.tcsPercentage} handleChange={(event) => props.handleChange(event, "tcsPercentage")}
                            // className={props.validState?.error?.tcsPercentage !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>TCS Amount</label>
                            <TextInput type="number" id="tcsAmt" name="tcsAmt" value={props.debitNoteDetails.tcsAmt} handleChange={(event) => props.handleChange(event, "tcsAmt")}
                                // className={props.validState?.error?.tcsAmt !== undefined ? "error" : ""} 
                                disabled
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mb-3.5">
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.debitNoteDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>

                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns" onClick={() => props.submitDebitNote()} disabled={props.isSaving}>
                            {props.debitNoteDetails.updateStatus === 1 ? "Update" : "Save"}
                        </button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    )
}